import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import "./DeclarationDetails.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, LoadingSpinner, ToastMessage } from '../../components'
import ItemList from '../../containers/ItemList/ItemList'
import havePermissionTo from '../../utils/havePermission';
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import formatDate from '../../helpers/formatDate';

function DeclarationDetails(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);
    const permissions = useSelector(state => state.authorization.permissions);

	const selectedDeclaration = useSelector(state => state.producerDeclaration.selectedProducerDeclaration);
	const isLoadingDetails    = useSelector(state => state.producerDeclaration.isLoadingDetails);
    const declarationDetails  = useSelector(state => state.producerDeclaration.declarationDetails);
    const isLoadingUpdate     = useSelector(state => state.producerDeclaration.isLoadingUpdate);
    const declarationHistoryList      = useSelector(state => state.producerDeclaration.declarationHistoryList.buscarHistoricoPorPedido);
    const normList            = useSelector(state => state.producerDeclaration.normList);
    
    const formLabels    = messages[lang].formAuditoriaDeclaracao
    const tableMessages = messages[lang].tableAuditoriaDeclaracao
	const titlePage     = messages[lang].auditoriaDeclaracao
	const tableMessagesHistory     = messages[lang].tableHistoricoDeclaracao

	const header = [
		tableMessages.sku,
		tableMessages.codigoItem,
	];

    const headerHistory = [
		tableMessagesHistory.reveiveDate,
		tableMessagesHistory.status,
		tableMessagesHistory.file,
	];

    const [saveButtonDisable, setDisableSaveButton] = useState(true);
    const [disableForm, setDisableForm] = useState(true);


    const declarationDetailsToast = useSelector(state => state.producerDeclaration.declarationDetailsToast);

    const [showToast, setShowToast]       = useState(false);    
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');
    const [statusError,  setStatusError]  = useState('-');

    const ACCEPT_TYPE = 'application/pdf';
    const [uploadedFile, setUploadedFile]  = useState(null);
    const [firstLoad,  setFirstLoad]  = useState(true);


	const pageBack = () => {
		history.push(`/declaration-list`);
    };

    useEffect(() => {
        if (firstLoad && selectedDeclaration && selectedDeclaration.pedido) {
            dispatch({
                type: 'GET_ORDER_DECLARATION_HISTORY',
                orderId: selectedDeclaration.pedido
            })
            return;
        }
        if (firstLoad || !selectedDeclaration) {
            return;
        }
        dispatch({
            type: 'GET_DECLARATION_DETAILS',
            id: selectedDeclaration.id
        })
        dispatch({
			type: 'GET_ORDER_DECLARATION_HISTORY',
			orderId: selectedDeclaration.pedido
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDeclaration]);

    useEffect(() => {	
        updateFields(
            { ...declarationDetails, file: uploadedFile },
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uploadedFile]);

    useEffect(() => {	
        setShowToast(declarationDetailsToast.showToast)
        setMessageError(declarationDetailsToast.message)
        setMessageType(declarationDetailsToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [declarationDetailsToast]);

	useEffect(() => {	
        if (props.history.location.erroRMS) {
            setStatusError(props.history.location.erroRMS)
        }

        dispatch({
			type: 'SET_DECLARATION_DETAILS_TOAST',
			payload: {
                showToast: false,
                message: "",
                messageType: "toast-success"
            }
		})

        if (havePermissionTo("edit-declaration-details", permissions)) {
            setDisableForm(false)
        }

		dispatch({
			type: 'GET_DECLARATION_DETAILS',
			id: selectedDeclaration.id
		})

        dispatch({
			type: 'GET_DECLARATION_NORMS'
		})
        setFirstLoad(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (normList[0] && normList[0].id !== 0) {
            normList.unshift({id: 0, codigo: null, descricao: ''})
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [normList]);

	const mappedTableList = () => {
		return declarationDetails.pedido.items.map((item) => {
			return [
					item.codItem,
                    {
                        text: item.detalheItems[0].descricaoItem,
                        maxLength: 200
                    }
				]

		});
	}

    const mappedDeclarationHistoryList = () => {
		return declarationHistoryList.map((item) => {
			return [
					formatDate(item.dataCadastro),
					item.status.descricao,
					item.file ? 
					{
						text: <i className="icon-download" />,
						onClick: () => {downloadPdf(item.file)},
					} : '',
				]

		});
	}
    
    const salvarDeclaracao = () => {
        dispatch({
            type: 'UPDATE_DECLARATION',
            declaration: declarationDetails
        })
        setUploadedFile(undefined);
        setDisableSaveButton(true);
    }

    const updateFields = (fields) => {
        setDisableSaveButton(false)
        dispatch({
          type: 'SET_NEW_DECLARATION_DETAILS',
          payload: fields
        })
      };

    const statusOptions = [
        { id: "1", message: "AGUARDANDO AVALIAÇÃO" },
        { id: "2", message: "APROVADO" },
        { id: "3", message: "REPROVADO" },
      ];

    const statusFecomercioOptions = [
        { id: "1", message: "NÃO ENVIADO" },
        { id: "2", message: "SOLICITAÇÃO DE CRIAÇÃO ENVIADA" },
        { id: "3", message: "SOLICITAÇÃO DE CRIAÇÃO EM ANÁLISE" },
        { id: "4", message: "CRIAÇÃO REPROVADA NA FECOMERCIO" },
        { id: "5", message: "CRIAÇÃO APROVADA NA FECOMERCIO" },
        { id: "6", message: "SOLICITAÇÃO DE ALTERAÇÃO ENVIADA" },
        { id: "7", message: "SOLICITAÇÃO DE ALTERAÇÃO EM ANÁLISE" },
        { id: "8", message: "ALTERAÇÃO REPROVADA NA FECOMERCIO" },
        { id: "9", message: "ALTERAÇÃO APROVADA NA FECOMERCIO" },
        { id: "10", message: "ERRO NA INTEGRAÇÃO" },
      ];

	const saveButton = disabled => () =>
		<ButtonStandard
			id="declaration_save_button"
			text={messages[lang].save}
			textClass="text-2"
			isLoading={isLoadingUpdate}
			disabled={disabled}
			className="btn btn-primary btn-save btn-light"
			onClick={() => salvarDeclaracao()}
		/>;

    const validateAndStoreLocalFile = file => {
        setUploadedFile(undefined);

        if (!file || file.length === 0) {
            setShowToast(true);
            setMessageType('toast-error')
            setMessageError(messages[lang].mustBePDF);
        } else if (file.length > 1) {
            setShowToast(true);
            setMessageError('error');
        } else if (file[0].type !== ACCEPT_TYPE) {
            setShowToast(true);
            setMessageError(messages[lang].mustBePDF);
        } else {
            setUploadedFile(file[0]);
            setDisableSaveButton(false);
        }
    };

    const removeFile = () => {
		setUploadedFile(undefined);
	};

    const downloadPdf = (file) => {
		const byteCharacters = window.atob(file);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], {type: 'application/pdf'});

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = messages[lang].filePDFProducerDeclaration;
		link.click();
	}

	return (
		<div className="declaration-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

            {

                isLoadingDetails ? 
                <div className="loader">
                    <LoadingSpinner />    
                </div> :

                <Container className="pt-3 justify-content-start">
                    <div key={declarationDetails}>
                    <Form className="px-3">
                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.numeroPedido}</Form.Label>                                
                                    <Form.Control
                                        className="text-2 border-radius-full"
                                        type="text"
                                        defaultValue={declarationDetails.pedido ? declarationDetails.pedido.id : ''}
                                        disabled={disableForm || true || isLoadingUpdate}
                                        onChange={event => updateFields(
                                        { ...declarationDetails, pedido: { ...declarationDetails.pedido, id: event.target.value } },
                                        )}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.fornecedor}</Form.Label>                                
                                    <Form.Control
                                        className="text-2 border-radius-full"
                                        type="text"
                                        defaultValue={declarationDetails.pedido ? declarationDetails.pedido.fornecedor.id + ' - ' + declarationDetails.pedido.fornecedor.nome : ''}
                                        disabled={disableForm || true || isLoadingUpdate}
                                        onChange={event => updateFields(
                                        {   ...declarationDetails, 
                                            pedido: { 
                                                ...declarationDetails.pedido, 
                                                fornecedor: {
                                                    ...declarationDetails.pedido.fornecedor,
                                                    id: event.target.value
                                                }
                                            } },
                                        )}
                                    />                                
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.itemFOBMin}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={declarationDetails.itemFOBMin ? declarationDetails.itemFOBMin : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, itemFOBMin: event.target.value },
                                    )}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.dataDeclaracao}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="date"
                                    defaultValue={declarationDetails.dataDeclaracao ? declarationDetails.dataDeclaracao : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, dataDeclaracao: event.target.value },
                                    )}
                                    />
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.itemFOBMax}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={declarationDetails.itemFOBMax ? declarationDetails.itemFOBMax : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, itemFOBMax: event.target.value },
                                    )}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.dataValidade}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="date"
                                    defaultValue={declarationDetails.dataValidade ? declarationDetails.dataValidade : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, dataValidade: event.target.value },
                                    )}
                                    />
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.status}</Form.Label>
                                <Form.Control
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={declarationDetails.status ? declarationDetails.status.id : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                        { ...declarationDetails, status: { ...declarationDetails.status, id: event.target.value } },
                                    )}
                                >
                                {
                                    statusOptions.map(value => (
                                        <option key={value.id} value={value.id}>{value.message}</option>
                                    ))
                                }      
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.normaDeclaracaoProdutor}</Form.Label>
                                <Form.Control
                                    required
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={declarationDetails.normaDeclaracaoProdutor ? declarationDetails.normaDeclaracaoProdutor.codigo : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                        { ...declarationDetails, normaDeclaracaoProdutor: event.target.value },
                                    )}
                                >
                                    {
                                        normList.map(value => (
                                            <option key={value.codigo} value={value.codigo}>{value.codigo}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.protocoloFecomercio}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={''}
                                    disabled={true || disableForm || isLoadingUpdate}
                                    onChange={() => setDisableSaveButton(false)}/>
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.statusFecomercio}</Form.Label>
                                <Form.Control
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={declarationDetails.statusFecomercio ? declarationDetails.statusFecomercio.id : ''}
                                    disabled={true}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, statusFecomercio: { ...declarationDetails.statusFecomercio, id: event.target.value } },
                                    )}
                                >
                                {
                                    statusFecomercioOptions.map(value => (
                                        <option key={value.id} value={value.id}>{value.message}</option>
                                    ))
                                }      
                                </Form.Control>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.numeroDJO}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    defaultValue={declarationDetails.numeroDJO ? declarationDetails.numeroDJO : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, numeroDJO: event.target.value },
                                    )}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.dataDJO}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="date"
                                    defaultValue={declarationDetails.dataDJO ? declarationDetails.dataDJO : ''}
                                    disabled={disableForm || isLoadingUpdate}
                                    onChange={event => updateFields(
                                    { ...declarationDetails, dataDJO: event.target.value },
                                    )}
                                    />
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col}>
                                <Form.Label className="text-2">{formLabels.motivoErro}</Form.Label>                                
                                    <Form.Control
                                        as="textarea"
                                        className="text-2 border-radius-full"
                                        type="text"
                                        rows={2}
                                        defaultValue={statusError}
                                        disabled={true}
                                    />
                            </Form.Group>
                        </Row>
                    </Form>
                    </div>
                </Container>
	
            }

            {
                declarationDetails.pedido ?
                <Container className="pt-3 justify-content-start">
                    <Container className="mt-1 pt-1 mb-4">
                        <ItemList
                            header={header}
                            titleTable={tableMessages.title}
                            listTable={mappedTableList()}
                            isLoading={isLoadingDetails}
                            />
                    </Container>
                </Container>
                : null
            }

            { 
                declarationDetails.pedido &&
                <Container className="pt-3 justify-content-start mt-1 pt-1 mb-4">
                    <Form.Label className="text-2">{formLabels.arquivoDeclaracaoProdutor}</Form.Label>
                    <UploadFiles
                        validateAndStoreLocalFile={validateAndStoreLocalFile}
                        uploadedFile={uploadedFile}
                        removeFile={uploadedFile ? removeFile : null}
                        downloadFile={null}
                        accept={ACCEPT_TYPE}
                    />
                </Container>
            }

            { 
                !isLoadingDetails && declarationHistoryList &&
                <Container className="pt-3 justify-content-start">
                    <Container className="mt-1 pt-1 mb-4 pb-5">
                        <ItemList
                            header={headerHistory}
                            titleTable={tableMessagesHistory.title}
                            listTable={declarationHistoryList ? mappedDeclarationHistoryList() : []}
                            isLoading={declarationHistoryList && declarationHistoryList.length > 0 ? false : true}
                            />
                    </Container>
                </Container>
            }

			<FooterActions
				ButtonGroupRight={saveButton(saveButtonDisable)}/>
		</div>
	)
}

export default withRouter(DeclarationDetails);